import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c108de76"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_2 = {
  style: {"text-align":"center"},
  "element-loading-text": "正在提交数据，请稍后"
}
const _hoisted_3 = { style: {"text-align":"left"} }
const _hoisted_4 = { class: "voa-select-list" }
const _hoisted_5 = { style: {"padding-top":"10px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_GbTables = _resolveComponent("GbTables")!
  const _component_GbDialog = _resolveComponent("GbDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_input, {
      modelValue: _ctx.selectText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectText) = $event)),
      readonly: ""
    }, _createSlots({ _: 2 }, [
      (!_ctx.props.priview)
        ? {
            name: "append",
            fn: _withCtx(() => [
              _createVNode(_component_el_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "voa-sp-btn",
                    onClick: _ctx.pMethods.onDialogBtnClick
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          }
        : undefined
    ]), 1032, ["modelValue"]),
    _createVNode(_component_GbDialog, {
      modelValue: _ctx.showDialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDialog) = $event)),
      title: "用户选择"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: _ctx.loading || _ctx.tableObject.loading,
          onClick: _ctx.pMethods.onSureBtnClick
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          type: "info",
          disabled: _ctx.loading || _ctx.tableObject.loading,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.search.search_key,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.search_key) = $event)),
              placeholder: "请输入审批人员姓名查询",
              class: "input-with-select",
              onChange: _ctx.pMethods.onInputChange
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: _ctx.Search,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSearchParams(_ctx.search)))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectList, (user) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: user.id,
                closable: "",
                onClose: ($event: any) => (_ctx.pMethods.onTagClosed(user))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.name), 1)
                ]),
                _: 2
              }, 1032, ["onClose"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_GbTables, {
              pageSize: _ctx.tableObject.pageSize,
              "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tableObject.pageSize) = $event)),
              currentPage: _ctx.tableObject.currentPage,
              "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tableObject.currentPage) = $event)),
              selection: false,
              columns: _ctx.tabColumns,
              data: _ctx.tableObject.tableList,
              loading: _ctx.tableObject.loading,
              pagination: { total: _ctx.tableObject.total },
              onRegister: _ctx.register
            }, {
              action: _withCtx(({ row }) => [
                _createVNode(_component_ElButton, {
                  type: "primary",
                  link: "",
                  onClick: ($event: any) => (_ctx.pMethods.selectUser(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}